<template>
  <section class="main card plans section--full-width">
    <header class="card-header">
      <h2>Visão geral da assinatura</h2>
    </header>

    <upgrade-alert />

    <discount-alert class="mx-6" />

    <article class="overview">
      <section class="overview__section overview__section--half card">
        <h3 class="overview__title">
          Meu plano
        </h3>

        <div class="overview__content">
          <div class="my-2 mb-2 h-auto w-full flex flex-row items-center justify-start">
            <dr-icon
              class="h-12 w-12 mr-3 block"
              name="planPremium"
            />

            <p class="m-0 p-0 font-medium text-lg">
              Plano
              <span class="uppercase" v-if="currentPlan.id === 1">
                GRATUITO
              </span>
              <span class="uppercase" v-if="currentPlan.id === 9">
                PREMIUM
              </span>
              <span class="uppercase" v-if="currentPlan.id === 10">
                MARKETPLACE
              </span>
            </p>
          </div>

          <div class="overview__actions">
            <button
              :class="{ '!ml-auto !mr-0': !plan.isPro }"
              class="btn btn-green overview__cta overview__cta--left"
              @click="$router.push({ name: 'DoctorPlansDetails' })"
            >
              Ver planos
            </button>

            <button
              v-if="plan.isPro"
              class="btn btn-primary overview__cta"
              @click="$router.push({ name: 'DoctorPlansCheckout' })"
            >
              Seja PREMIUM
            </button>
          </div>
        </div>
      </section>

      <section class="overview__section overview__section--half card">
        <h3 class="overview__title">
          Cartão de crédito {{ defaultCard && defaultCard['is_default'] ? 'padrão' : '' }}
        </h3>

        <div class="overview__content">
          <div class="my-2 mb-6 h-auto w-full flex flex-row items-center justify-start">
            <!-- Icon credit card -->
            <dr-icon
              v-if="false"
              class="h-12 w-12 mr-3 block"
              name="planPremium"
            />

            <div>
              <template v-if="ui.isLoadingCard">
                <dr-loader
                  size="lg"
                  class="m-auto p-4 self-center"
                />
              </template>

              <template v-if="!ui.isLoadingCard && defaultCard">
                <div class="flex flex-row items-start justify-start">
                  <img
                    :src="getCardBrand(defaultCard.brand)"
                    class="brand-icon"
                  />

                  <div>
                    <p class="m-0 p-0 font-medium text-base">
                      Final
                      <span class="font-bold">
                        {{ defaultCard['last_digits'] }}
                      </span>
                      /
                      Expira em
                      <span class="font-bold">
                        {{ defaultCard['expiration_date'] | toExpDate }}
                      </span>
                    </p>

                    <!-- <p class="m-0 p-0 mt-2 text-sm">
                      <strong>Data de renovação:</strong> Dia 5
                    </p> -->
                  </div>
                </div>
              </template>

              <template v-if="!ui.isLoadingCard && !defaultCard">
                <p class="m-0 p-0 font-normal text-sm">
                  Você ainda não tem cartões cadastrados.
                </p>
              </template>
            </div>
          </div>

          <div class="overview__actions">
            <button
              v-if="ui.showCardListButton"
              class="btn btn-green overview__cta overview__cta--left"
              @click="ui.showModalCardList = true"
            >
              Meus cartões
            </button>

            <button
              class="btn btn-primary overview__cta"
              @click="ui.showModalCardNew = true"
            >
              Novo cartão
            </button>
          </div>
        </div>
      </section>

      <!-- Learn more -->
      <!-- <section
        v-if="plan.isPro"
        class="overview__section card"
      >
        <h3 class="overview__title">
          Conheça melhor as vantagens e os planos Dr. Conecta
        </h3>

        <p>
          Assista ao vídeo abaixo e saiba como ter acesso a todos
          os recursos Dr. Conecta.
        </p>

        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/HROeErv_0PI"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="mx-auto"
        />
      </section> -->

      <section class="overview__section card">
        <h3 class="overview__title">
          Meus recibos
        </h3>

        <receipts-list
          class="mt-3"
          :has-pagination="false"
          :max-lines="6"
        />

        <div class="mt-4 w-full flex items-center justify-end">
          <button
            class="btn btn-primary overview__cta"
            @click="$router.push({ name: 'DoctorPlansReceipts' })"
          >
            Ver todos
          </button>
        </div>
      </section>
    </article>

    <!-- Modal new credit card -->
    <credit-card-new-modal
      v-if="ui.showModalCardNew"
      @update="getCards"
      @close="ui.showModalCardNew = false"
    />

    <!-- Modal list credit card -->
    <credit-card-list-modal
      v-if="ui.showModalCardList"
      @update="getCards"
      @close="ui.showModalCardList = false"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import upgradeAlert from './upgradeAlert'
import receiptsList from './receiptsList'
import discountAlert from './alertDiscount'
import creditCardNewModal from './creditCardNewModal'
import creditCardListModal from './creditCardListModal'
import visa from '@/assets/img/credit-card/visa.png'
import master from '@/assets/img/credit-card/mastercard.png'
import elo from '@/assets/img/credit-card/elo.png'
import american from '@/assets/img/credit-card/americanExpress.png'
import hipercard from '@/assets/img/credit-card/hipercard.png'
import genericBrand from '@/assets/img/credit-card/genericCard.png'

export default {
  name: 'PlansOverview',

  filters: {
    toExpDate (str) {
      return str.replace(/(\d{2})(\d{2})/gi, '$1/$2')
    }
  },

  components: {
    discountAlert,
    upgradeAlert,
    receiptsList,
    creditCardNewModal,
    creditCardListModal
  },

  data () {
    return {
      currentPlan: null,
      ui: {
        showModalCardNew: false,
        showModalCardList: false,
        isLoadingCard: true,
        showCardListButton: false
      },
      cards: null
    }
  },

  computed: {
    ...mapGetters({ plan: 'getPlan' }),

    defaultCard () {
      if (Array.isArray(this.cards) && this.cards.length > 0) {
        return this.cards.find((card) => card['is_default']) || this.cards[0]
      }

      return null
    }
  },

  created () {
    this.fn_HIDE_PROGRESS()

    this.getCards()
  },

  mounted () {
    this.getcurrentPlan()
  },
  methods: {
    getcurrentPlan () {
      const url = '/doctor/doctor_subscription_plan'

      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then(response => {
          this.currentPlan = response.data.subscription_plan
        })
        .catch((err) => { return err })
    },
    getCards () {
      this.fn_SHOW_PROGRESS()
      this.ui.isLoadingCard = true
      this.$http
        .get('/user/credit_card', this.$store.getters.getAuthHeader)
        .then((res) => {
          if (res.data.length > 0) {
            this.cards = res.data
            this.ui.showCardListButton = true
            return
          }

          this.cards = []
          this.ui.showCardListButton = false
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.ui.isLoadingCard = false
        })
    },

    getCardBrand (brand) {
      switch (true) {
        case brand === 'visa':
          return visa

        case brand === 'mastercard':
          return master

        case brand === 'elo':
          return elo

        case brand === 'amex':
          return american

        case brand === 'hipercard':
          return hipercard

        default:
          return genericBrand
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.overview {
  @apply flex flex-row items-start justify-between flex-wrap;
  padding: 0 30px 30px 30px;

  &__section {
    @apply p-4 self-stretch h-auto;
    background: #f4f4f4;
    box-sizing: border-box;
    flex: 0 0 100%;
    margin-bottom: 1rem;

    &--half {
      flex: 0 0 calc(50% - 0.5rem);
    }
  }

  &__title {
    @apply text-green;
    font-family: $font1;
    font-size: 1rem;
  }

  &__content {
    @apply flex flex-row flex-wrap items-start justify-start;
    height: 100%;
  }

  &__actions {
    @apply flex flex-row items-center justify-start;
    flex: 0 0 100%;
    margin-top: auto;
  }

  &__cta {
    @apply flex items-center justify-center;
    @apply p-1 px-5 !#{important};
    font-size: 0.75rem;
    height: 1.9rem;
    margin-left: auto;

    &--left {
      margin-left: unset;
      margin-right: auto;
    }
  }
}

.brand-icon {
  @apply mr-3;
  max-height: 3rem;
  max-width: 3.5rem;
  width: auto;
}
</style>
